import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const bestGardenPicksStyles: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white',
  COMMONS_APPBAR_BG: 'bg-zinc-950',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white [&>path]:stroke-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',
  COMMONS_FOOTER_BG: 'bg-zinc-950',
  COMMONS_FOOTER_TEXT: 'text-white',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#225D2D] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: '',
  HOMEPAGE_HEADER_BG: 'bg-[#225D2D]',
  HOMEPAGE_HEADER_TEXT: 'text-white',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#C5FE00]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#C5FE00]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-white',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-white',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#C5FE00] hover:border-[#C5FE00] hover:bg-[#C5FE00] hover:text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#C5FE00]',

  HOMEPAGE_RANK_BANNER_BG: 'bg-zinc-950',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-zinc-950',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#C5FE00]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#225D2D] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#225D2D] text-[#225D2D] [&>svg>path]:stroke-[#225D2D] [&>svg>g>path]:stroke-[#225D2D] [&>svg>path]:fill-[#225D2D] [&>svg>g>path]:fill-[#225D2D]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#225D2D]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-zinc-950',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#225D2D]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-white',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#C5FE00]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#225D2D]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-white',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-white',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-zinc-950 [&>.explore-icon-fill]:!fill-[#225D2D] [&>g>.explore-icon-fill]:!fill-[#225D2D]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#225D2D] [&>.vector-top>path]:fill-zinc-950 [&>.vector-bottom>path]:fill-zinc-950]',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-white',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-gray-200',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#94B506]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-white',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#E7E5E4]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-[#3F3F46]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#FB923C]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-white',
  LISTPAGE_BADGE_WINNER_DIVIDER: '',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#FB923C]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-white',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#C5FE00]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-[#030303]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#C5FE00]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-[#030303]',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#C5FE00]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-[#030303]',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#FB923C] ',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#FB923C]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#C5FE00]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-white ',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:fill-black',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#030303]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#225D2D] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#225D2D] text-[#225D2D] [&>svg>path]:stroke-[#225D2D] [&>svg>g>path]:stroke-[#225D2D] [&>svg>path]:fill-[#225D2D] [&>svg>g>path]:fill-[#225D2D]',
  LISTPAGE_BUTTON_LINK: 'text-[#225D2D]',
  LISTPAGE_ANCHOR_LINK: 'text-[#225D2D]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#225D2D]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#225D2D]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#225D2D]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#225D2D] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#225D2D] text-[#225D2D]  [&>svg>path]:stroke-[#225D2D] [&>svg>g>path]:stroke-[#225D2D] [&>svg>path]:fill-[#225D2D] [&>svg>g>path]:fill-[#225D2D]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#225D2D]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#225D2D]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#225D2D]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#225D2D]',
  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-[#225D2D]',
  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#225D2D]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#94B506] [&>.vector-top>path]:fill-[#C5FE00] [&>.vector-bottom>path]:fill-[#225D2D]',
  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-neutral-100',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-blue-100 [&>circle]:stroke-blue-100 [&>path]:fill-black',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-blue-50',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-black',
  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:bg-[#C5FE00] data-[focus]:text-black',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'bg-[#225D2D] text-white',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#225D2D]',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container',
}
